import React, { Component } from 'react';

export class CourseDetailsLink extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let detailsUrl = `${this.props.documentLocation}`;

        if (detailsUrl) {
            return <span className="small hidden-print"><br/><a target="_blank" rel="noopener noreferrer" href={detailsUrl}>Click for course details</a></span>;
        }

        return null;
    }
}